import type { Translations } from "../types";

const he: Translations = {
  "meta.title": "קליקים לפי מדינה על המפה",
  "meta.description":
    "מפת עולם אינטראקטיבית: קליקים חינמיים לכל מדינה, וגם תמיכה בתשלום דרך Stripe, PayPal ו-Buy Me a Coffee.",

  "app.title": "קליקים לפי מדינה על המפה",

  "map.intro":
    "לחצו על מדינה במפה כדי להעניק לה קליק חינמי, או שלחו לה תמיכה כספית - שניהם נספרים בטבלת המובילות המשולבת למטה. המפה משקפת רק תמיכה בתוך האפליקציה הזו, לא עושר לאומי או תמ״ג אמיתיים.",
  "map.verifying": "מאמת …",
  "map.confirmNotRobot": "לפני שתוכלו להוסיף קליקים חינמיים, אשרו בבקשה שאתם לא רובוט:",
  "map.tryAgain": "נסו שוב",
  "map.registeringClick": "רושם קליק …",
  "map.selectedCountry": "מדינה נבחרה: {name}.",
  "map.selectFirstFeedback": "המדינה נבחרה. כדי להוסיף קליק חינמי, קודם אשרו למטה שאתם לא רובוט.",
  "map.verificationExpired": "האימות פג - אשרו שוב שאתם לא רובוט.",
  "map.slowDown": "לאט קצת יותר - המתינו רגע לפני הקליק הבא.",
  "map.clickFailed": "לא הצלחנו לרשום את הקליק. נסו שוב.",
  "map.clickErrorGeneric": "שגיאה ברישום הקליק.",
  "map.leaderboardHeading": "טבלת המובילות של המדינות",
  "map.emptySelection": "בחרו מדינה על המפה כדי להעניק לה קליק או לתמוך בה.",
  "map.loadingData": "טוען נתונים …",

  "worldmap.loadError": "לא הצלחנו לטעון את המפה.",
  "worldmap.resetZoom": "איפוס תקריב",
  "worldmap.resetButton": "⤾ איפוס",
  "worldmap.loadingMap": "טוען מפה …",
  "worldmap.unknownCountry": "לא ידוע",
  "worldmap.ariaClicks": "{name}: {clicks} קליקים",
  "worldmap.tooltipClicks": "{clicks} קליקים",

  "legend.fewer": "פחות קליקים",
  "legend.more": "יותר קליקים",

  "list.empty": "אין עדיין קליקים. היו הראשונים!",
  "list.ariaLabel": "טבלת מובילות המדינות לפי קליקים",

  "human.siteKeyMissing": "המשתנה VITE_TURNSTILE_SITE_KEY אינו מוגדר - ראו את קובץ ה-README להגדרות.",
  "human.verificationFailedGeneric": "האימות נכשל.",
  "human.networkError":
    "לא הצלחנו להגיע לשירות האימות (שגיאת רשת) - בדקו את VITE_SUPABASE_URL, שה-verify-human פרוס, ואת ALLOWED_ORIGIN; ראו README/NAVODILA.",
  "human.verificationFailedRetry": "האימות נכשל, נסו שוב.",

  "provider.stripe": "💳 כרטיס אשראי (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "המדינה הנבחרת",
  "panel.currentlyRanked": "כרגע במקום #{rank}",
  "panel.shareCopied": "הועתק ✓",
  "panel.shareShared": "שותף ✓",
  "panel.shareButton": "🔗 שיתוף",

  "panel.tableClicks": "קליקים",
  "panel.tableFree": "חינם",
  "panel.tablePaid": "בתשלום",
  "panel.rowAllTime": "כל הזמנים",
  "panel.rowThisYear": "השנה",
  "panel.rowThisWeek": "השבוע",
  "panel.rowToday": "היום",

  "panel.totalCombined": "סה״כ משולב:",
  "panel.totalSupport": "סה״כ תמיכה:",

  "panel.paymentMethod": "אמצעי תשלום",
  "panel.noPaymentMethod": "כרגע אין אמצעי תשלום זמין.",
  "panel.supportAmount": "סכום התמיכה (EUR)",
  "panel.amountRange": "הסכום צריך להיות בין {min} ל-{max}.",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "קליקים בתשלום משוערים:",
  "panel.ratioInfo":
    "יחס: {a} = {b} קליקים (למשל {c} = {d} קליקים). זו רק הערכה לפני התשלום - מספר הקליקים הסופי תמיד מחושב ומאושר על ידי השרת בהתאם לתשלום שאושר בפועל.",
  "panel.preparing": "מכין …",
  "panel.continueWith": "המשיכו עם {provider}",
  "panel.choosePaymentMethod": "בחרו אמצעי תשלום",
  "panel.bmcUsernameMissing": "המשתנה VITE_BMC_USERNAME אינו מוגדר - ראו את קובץ ה-README להגדרות.",
  "panel.paypalClientIdMissing": "המשתנה VITE_PAYPAL_CLIENT_ID אינו מוגדר - ראו את קובץ ה-README להגדרות.",

  "panel.paypalAmountInfo": "סכום: {amount} (משוערים {clicks} קליקים). השלימו את התשלום עם כפתור ה-PayPal שלמטה.",
  "panel.back": "← חזרה",

  "panel.bmcWarningTitle": "⚠️ לפני שתמשיכו ל-BuyMeCoffee:",
  "panel.bmcWarningBody":
    "הדביקו את הקוד שלמטה בשדה ההודעה/הערה בקופה — זו הדרך היחידה שבה נדע לאיזו מדינה אתם תומכים. בלי הקוד לא נוכל לשייך את התשלום לאף מדינה.",
  "panel.copy": "העתקה",
  "panel.copied": "הועתק ✓",
  "panel.suggestedAmount": "סכום מוצע:",
  "panel.bmcAmountNote":
    "(משוערים {clicks} קליקים). לצערנו BuyMeCoffee אינו תומך בהעברת הסכום דרך הקישור — הזינו/בחרו אותו בעצמכם באתר שלהם. מספר הקליקים בפועל תמיד מחושב מהסכום שאתם שולחים בפועל ב-BuyMeCoffee, לא מהערכה הזו.",
  "panel.openBmc": "פתחו את BuyMeCoffee והמשיכו →",
  "panel.waitingProvider": "ממתינים לאישור התשלום מספק שירותי התשלום …",
  "panel.waitingConfirmation": "ממתינים לאישור התשלום …",
  "panel.timedOut":
    "הבדיקה ארכה זמן רב מדי. אם השלמתם את התשלום, המפה תתעדכן ברגע שהשרת יקבל אישור - לפעמים זה עשוי לקחת קצת יותר זמן.",
  "panel.checkAgain": "בדקו שוב",

  "panel.cancelled": "התשלום בוטל או לא הושלם. המפה לא השתנתה.",
  "panel.tryAgain": "נסו שוב",

  "panel.confirmed": "✅ התמיכה אושרה!",
  "panel.confirmedBody": "{country} קיבלה {clicks} קליקים בתשלום עבור {amount}.",

  "panel.errorPreparingSupport": "שגיאה בהכנת התמיכה שלכם.",
  "panel.errorPreparingPayment": "שגיאה בהכנת התשלום.",
  "panel.errorConfirmingPayment": "שגיאה באישור התשלום.",
  "panel.errorPayingPaypal": "שגיאה בתשלום דרך PayPal.",

  "share.unranked": "{flag}{country} זקוקה לתמיכה שלכם במפת העולם!\nעזרו לה לטפס בטבלת המובילות 👇",
  "share.rank1": "{flag}{country} נמצאת כרגע במקום #1!\nעזרו לנו להישאר בפסגה 👇",
  "share.rankN": "{flag}{country} נמצאת כרגע במקום #{rank}!\nעזרו לנו להגיע למקום #1 👇",

  "language.switcherLabel": "שפה",
};

export default he;
